import { type TaxonomyCriterion } from "types/models";

export const nestCriteria = (items: TaxonomyCriterion[], id?: TaxonomyCriterion['id']): TaxonomyCriterion[] =>
   items
      .filter((item) => item?.parent?.id === id)
      .sort((a, b) => (a?.key && b?.key ? a.key.localeCompare(b.key) : a.id - b.id))
      .map((item) => ({ ...item, criteria: nestCriteria(items, item.id) }));